import React from 'react';
import { AssessmentType } from '../../../services/reachService';
import { Trophy, TrendingUp, Users, UserCheck, LayoutGrid, ChevronRight } from 'lucide-react';

const TYPES: { value: AssessmentType; label: string; description: string; icon: React.ElementType }[] = [
  { value: 'champion', label: 'Change Champion', description: 'For nominated change champions driving adoption in their team.', icon: Trophy },
  { value: 'executive', label: 'Executive Sponsor', description: 'For senior leaders with visible sponsorship responsibility.', icon: TrendingUp },
  { value: 'practice-leader', label: 'Practice Leader', description: 'For managers and team leads accountable for their area\'s adoption.', icon: Users },
  { value: 'user', label: 'End User', description: 'For anyone directly impacted by the change in their day-to-day work.', icon: UserCheck },
  { value: 'general', label: 'General', description: 'Suitable for any stakeholder — not role-specific.', icon: LayoutGrid },
];

interface Props {
  onSelect: (type: AssessmentType) => void;
  counts?: Partial<Record<AssessmentType, number>>;
}

export const AssessmentSelector: React.FC<Props> = ({ onSelect, counts = {} }) => (
  <div className="flex flex-col gap-3">
    <p className="text-[11px] font-bold text-primary tracking-widest uppercase">Select assessment type</p>
    {TYPES.map(t => {
      const Icon = t.icon;
      const count = counts[t.value];
      return (
        <button
          key={t.value}
          onClick={() => onSelect(t.value)}
          className="flex items-center justify-between p-4 rounded-xl border border-[#e2e8f0] bg-white text-left hover:border-primary/40 hover:bg-slate-50 transition-all group"
        >
          <div className="flex items-center gap-4">
            <div className="w-10 h-10 rounded-lg bg-slate-100 text-slate-400 flex items-center justify-center flex-shrink-0 group-hover:bg-primary/10 group-hover:text-primary transition-colors">
              <Icon size={18} />
            </div>
            <div>
              <p className="text-sm font-semibold text-navy">{t.label}</p>
              <p className="text-xs text-slate-500 mt-0.5">{t.description}</p>
            </div>
          </div>
          <div className="flex items-center gap-3 flex-shrink-0">
            {count !== undefined && count > 0 && (
              <span className="text-[11px] font-semibold px-2 py-0.5 rounded-full bg-primary/10 text-primary">
                {count} submitted
              </span>
            )}
            <ChevronRight size={16} className="text-slate-300 group-hover:text-primary transition-colors" />
          </div>
        </button>
      );
    })}
  </div>
);
